import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SideBar from '../common/SideBar'
import { useState } from 'react'
import { getBusinessList } from '../../../services/operations/AdminPageAPI'
import search from "../../../assets/Group 33509.png";
import debounce from "lodash.debounce";
import Table from './Table'

const BusinessList = () => {

   const [searchQuery, setSearchQuery] = useState("");
   const [result,setResult]=useState([]);
     const [pagination, setPagination] = useState({
           current_page: 1,
           per_page: 15,
           to: 1,
           total_recruiters: 0,
       });
   
    const user=useSelector((state)=>state.profile.user)
    const token=useSelector((state)=>state.auth.token)
    const dispatch=useDispatch()


    const fetchBusinessList = async (page = 1) => {

      const q = searchQuery.trim();
  const response = await dispatch(
    getBusinessList(token, q === "" ? "" : q, page) 
  );
  const businessListData = response?.data?.data;
  if (businessListData?.data?.data?.length) {
    setResult(businessListData.data.data);

    setPagination((prev) => ({
      ...prev,
      current_page: businessListData.data.current_page || 1,
      per_page: businessListData.data.per_page || prev.per_page,
      total_recruiters: businessListData.data.total || 0,
      total_pages: businessListData.data.last_page || 1,
    }));
  } else {
    setResult([]);
    setPagination((prev) => ({
      ...prev,
      current_page: 1,
      total_recruiters: 0,
      total_pages: 1,
    }));
  }
};

       
useEffect(() => {
  fetchBusinessList(pagination.current_page);
}, [searchQuery, pagination.current_page]);


 const handlePageChange = (newPage) => {
        setPagination((prev) => ({ ...prev, current_page: newPage }));
    };

      const handleSearch = debounce((query) => {
            setSearchQuery(query);
            setPagination((prev) => ({ ...prev, current_page: 1 }));
        }, 300);
    
        const handleSearchInputChange = (event) => {
            const query = event.target.value.trim();
            handleSearch(query);
        };
  return (
   
     <div className="admin-dashboard-container">
      <SideBar user={user} />
      <div className="admin-dashboard-content">
        <div className="recruiter-heading" style={{ marginBottom: "15px" }}>
                        <div className="resume-title">
                            <h5 style={{ fontSize: "24px", fontWeight: "600" }}>
                                Business Listing&nbsp;
                               
                                    <span style={{ color: "#666666" }}>
                                        ({pagination.total_recruiters})
                                    </span>
                            </h5>
                        </div>
                        <div className="resume-controls" style={{gap:"15px"}}>
                            <div className="search-container-recruiter">
                                <img src={search} alt="Search" className="search-icon" />
                                <input
                                    type="text"
                                    id="search"
                                    placeholder="Search Business"
                                    className="search-bar"
                                    style={{ borderRadius: "8px" }}
                                    onChange={handleSearchInputChange} 
                                />
                            </div>
                        </div>
                    </div>
                    <Table
                    data={result}
                            pagination={pagination}
                            fetchRecruiters={fetchBusinessList}
                            onPageChange={handlePageChange}/>

        </div>
        </div>
  )
}

export default BusinessList